import React from 'react';
import './ui.css';

export function YCard({ title, header, footer, children, className = '', bodyClassName = '', headerVariant, headerGradient = false, ...rest }) {
  const headerClasses = [
    'y-card-header',
    headerVariant || '',
    headerGradient ? 'brand-gradient' : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={`y-card ${className}`} data-yona="card" {...rest}>
      {(title || header) && (
        <div className={headerClasses}>
          {title ? <h3 className="y-card-title">{title}</h3> : header}
        </div>
      )}
      <div className={`y-card-body ${bodyClassName}`}>{children}</div>
      {footer && <div className="y-card-footer">{footer}</div>}
    </div>
  );
}

